import { render, staticRenderFns } from "./SettingsColumn.vue?vue&type=template&id=4a4c1d57&"
import script from "./SettingsColumn.vue?vue&type=script&lang=js&"
export * from "./SettingsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports